<template>
  <v-app class="font-lato report-templates-detail">

    <div class="report-detail-container position-relative">
      <!-- Sidebar -->
      <RightSidebar />
      <!-- Column Index New -->
      <ColumnIndex />
      <!-- Content -->
      <ColumnDetail />
      <!-- Footer -->
      <FooterAction />
    </div>

    <ModalConfirmation v-if="isConfirmShow" />
    <Banner :banner="banner" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import RightSidebar from './templates_detail/RightSidebar.vue';
import ColumnDetail from './templates_detail/ColumnDetail.vue';
import FooterAction from './templates_detail/FooterAction.vue';
import ColumnIndexDrawer from './templates_detail/ColumnIndexDrawer.vue';
import ColumnIndex from './templates_detail/ColumnIndex.vue';
import ModalConfirmation from './ModalConfirmation.vue';
import Banner from '../Banner.vue'

export default {
  components: {
    RightSidebar,
    ColumnDetail,
    FooterAction,
    ColumnIndexDrawer,
    ColumnIndex,
    ModalConfirmation,
    Banner,
  },
  data() {
    return {
      selectedColumns: [],
    }
  },
  computed: {
    ...mapGetters({
      isConfirmShow: "reportTemplates/isConfirmShow",
      banner: 'reportTemplates/banner',
      hasUnsavedChanges: "reportTemplates/hasUnsavedChanges",
      unsavedChanges: "reportTemplates/unsavedChanges",
    }),
  },
  methods: {
    checkSwitchTab(e) {
      const allowedClasses = ['brc-item', 'breadcrumb-link', 'nav-item', 'link-sidebar', 'link-sub-sidebar'];

      const navItem = e.target.closest(allowedClasses.map(cls => `.${cls}`).join(', '));

      if (navItem) {
        if (this.hasUnsavedChanges || this.unsavedChanges) {
          e.preventDefault();
          e.stopPropagation();

          const redirectPath = navItem.getAttribute('href') || navItem.querySelector('a')?.getAttribute('href');

          this.$store.commit('reportTemplates/setConfirmShow', {
            isShow: true,
            type: 'changes',
            title: 'Unsaved Changes',
            description: "Looks like you've made some changes. Don't forget to save before you go!",
            redirect: redirectPath || '',
          });
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch('reportTemplates/getReportTemplateById', this.$route.params.id)
    document.addEventListener('click', this.checkSwitchTab);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.checkSwitchTab);
  },
};
</script>

<style lang="scss" scoped>
.report-templates-detail {
  .report-detail-container {
    height: calc(100vh - 58px);
    background-color: #f4f4f4;
    display: flex;
  }

  .report-sidebar {
    width: 448px;
    height: 100%;
    background-color: #FFFFFF;
    border-right: 1px solid #D7D7D7;
  }
}
</style>